// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusListCount_wrapper__u0OUv","totalCount":"StatusListCount_totalCount__cyBdd","itemCount":"StatusListCount_itemCount__TlFJQ","unit":"StatusListCount_unit__p4qQl"};